import { render, staticRenderFns } from "./BlockQuoteButton.vue?vue&type=template&id=3d95f2f1&"
import script from "./BlockQuoteButton.vue?vue&type=script&lang=js&"
export * from "./BlockQuoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports